import React from 'react';
import AddPortfolio from '../AddPortfolio/AddPortfolio';

const Main = () => {
    return (
        <div>
           <h2 className="text-4xl text-center">admin </h2> 
           <AddPortfolio/>
        </div>
    );
};

export default Main;